// Minimal Boho
import minimalBohoCover from "../assets/img/Minimal Boho House/Minimal_Boho_House_cover.webp";
import minimalBoho1 from "../assets/img/Minimal Boho House/Minimal_Boho_House_1.webp";
import minimalBoho2 from "../assets/img/Minimal Boho House/Minimal_Boho_House_2.webp";
import minimalBoho3 from "../assets/img/Minimal Boho House/Minimal_Boho_House_3.webp";

// Le Havre
import leHavreCover from "../assets/img/Le Havre/Le_Havre_cover.webp";
import leHavre1 from "../assets/img/Le Havre/Le_Havre_1.webp";
import leHavre2 from "../assets/img/Le Havre/Le_Havre_2.webp";
import leHavre3 from "../assets/img/Le Havre/Le_Havre_3.webp";

// Elysium
import elysiumCover from "../assets/img/Elysium/Elysium_cover.webp";
import elysium1 from "../assets/img/Elysium/Elysium_1.webp";
import elysium2 from "../assets/img/Elysium/Elysium_2.webp";
import elysium3 from "../assets/img/Elysium/Elysium_3.webp";

// Le Soleil
import leSoleilCover from "../assets/img/Le Soliel/Le_Soliel_cover.webp";
import leSoleil1 from "../assets/img/Le Soliel/Le_Soliel_1.webp";
import leSoleil2 from "../assets/img/Le Soliel/Le_Soliel_2.webp";
import leSoleil3 from "../assets/img/Le Soliel/Le_Soliel_3.webp";

// Bliss
import blissCover from "../assets/img/Bliss/Bliss_cover.webp";
import bliss1 from "../assets/img/Bliss/Bliss_1.webp";
import bliss2 from "../assets/img/Bliss/Bliss_2.webp";
import bliss3 from "../assets/img/Bliss/Bliss_3.webp";

// Vatsalya
import vatsalyaCover from "../assets/img/Vatsalya/Vatsalya_cover.webp";
import vatsalya1 from "../assets/img/Vatsalya/Vatsalya_1.webp";
import vatsalya2 from "../assets/img/Vatsalya/Vatsalya_2.webp";
import vatsalya3 from "../assets/img/Vatsalya/Vatsalya_3.webp";

// Saanj
import saanjCover from "../assets/img/Saanj/Saanj_cover.webp";
import saanj1 from "../assets/img/Saanj/Saanj_1.webp";
import saanj2 from "../assets/img/Saanj/Saanj_2.webp";
import saanj3 from "../assets/img/Saanj/Saanj_3.webp";

// Angan (Aangan)
import anganCover from "../assets/img/Aangan/Aangan_cover.webp";
import angan1 from "../assets/img/Aangan/Aangan_1.webp";
import angan2 from "../assets/img/Aangan/Aangan_2.webp";
import angan3 from "../assets/img/Aangan/Aangan_3.webp";

// AC Studio (AC office)
import acStudioCover from "../assets/img/AC office/AC_office_cover.webp";
import acStudio1 from "../assets/img/AC office/AC_office_1.webp";
import acStudio2 from "../assets/img/AC office/AC_office_2.webp";
import acStudio3 from "../assets/img/AC office/AC_office_3.webp";

// Palmira
import palmiraCover from "../assets/img/Palmira/Palmira_cover.webp";
import palmira1 from "../assets/img/Palmira/Palmira_1.webp";
import palmira2 from "../assets/img/Palmira/Palmira_2.webp";
import palmira3 from "../assets/img/Palmira/Palmira_3.webp";

// Neelaya
import neelayaCover from "../assets/img/Neelaya/Neelaya_cover.webp";
import neelaya1 from "../assets/img/Neelaya/Neelaya_1.webp";
import neelaya2 from "../assets/img/Neelaya/Neelaya_2.webp";
import neelaya3 from "../assets/img/Neelaya/Neelaya_3.webp";

// Cassara
import cassaraCover from "../assets/img/Cassara/Cassara_cover.webp";
import cassara1 from "../assets/img/Cassara/Cassara_1.webp";
import cassara2 from "../assets/img/Cassara/Cassara_2.webp";
import cassara3 from "../assets/img/Cassara/Cassara_3.webp";

// Amara
import amaraCover from "../assets/img/Amara/Amara_cover.webp";
import amara1 from "../assets/img/Amara/Amara_1.webp";
import amara2 from "../assets/img/Amara/Amara_2.webp";
import amara3 from "../assets/img/Amara/Amara_3.webp";

// Aurelia
import aureliaCover from "../assets/img/Aurelia/Aurelia_cover.webp";
import aurelia1 from "../assets/img/Aurelia/Aurelia_2.webp";
import aurelia2 from "../assets/img/Aurelia/Aurelia_3.webp";
import aurelia3 from "../assets/img/Aurelia/Aurelia_4.webp";

// Reverie
import reverieCover from "../assets/img/Reverie/Reverie_cover.webp";
import reverie1 from "../assets/img/Reverie/Reverie_1.webp";
import reverie2 from "../assets/img/Reverie/Reverie_2.webp";
import reverie3 from "../assets/img/Reverie/Reverie_3.webp";

const projectsData = [
    {
        header: "MINIMAL BOHO",
        folder: "Minimal Boho House",
        paragraph: "In the heart of Mumbai, this home seamlessly blends the warmth of minimalism with the eclectic charm of bohemian style, creating a unique and inviting space that feels both relaxed and curated. The fusion of styles is expertly executed, providing a serene backdrop for the boho elements to shine.",
        images: [minimalBohoCover, minimalBoho1, minimalBoho2, minimalBoho3],
    },
    {
        header: "LE HAVRE",
        folder: "Le Havre",
        paragraph: "This Mumbai home artfully balances homeliness and simplicity with an underlying charm and vibrancy, perfectly suited for contemporary living. A space that is cohesive, charming, and inherently lively— a true sanctuary tailored for living well. At the heart of the design concept is the philosophy of creating a space that is not only aesthetically pleasing but also deeply functional and welcoming. The foundation of the design lies in a soft, neutral colour palette which serves as the canvas for layers of texture and color. This approach ensures that the home feel calm and expansive, yet dynamic enough to stimulate the senses.",
        images: [leHavreCover, leHavre1, leHavre2, leHavre3],
    },
    {
        header: "ELYSIUM",
        folder: "Elysium",
        paragraph: "Elysium is a refined example of contemporary minimalism, carefully crafted for a 1BHK residence in Mumbai. The design’s clean lines and neutral colour palette set the stage for a tranquil and sophisticated living space. A seamless blend of textures adds depth and character, transforming the apartment into a serene retreat amidst the city’s hustle and bustle. Each element within the home serves a purpose, enhancing both form and function, while maintaining a sense of visual harmony. The thoughtful use of space and light further elevates the ambiance, creating a home that feels spacious yet intimately inviting.",
        images: [elysiumCover, elysium1, elysium2, elysium3],
    },
    {
        header: "LE SOLEIL",
        folder: "Le Soliel",
        paragraph: "Le Soleil redefines modern chic with a refreshing blend of understated elegance and functionality. This 2BHK residence embraces clean lines, a neutral color palette, and soft pops of color that bring warmth to the home. The design seamlessly integrates modern elements with practical features, offering a tranquil yet inviting environment that resonates with a sophisticated urban lifestyle. Thoughtfully curated textures create a harmonious balance between comfort and style, making the space feel both contemporary and welcoming.",
        images: [leSoleilCover, leSoleil1, leSoleil2, leSoleil3],
    },
    {
        header: "BLISS",
        folder: "Bliss",
        paragraph: "Every inch of this 700-square-foot apartment tells a story of thoughtful design and serene living. This home is a haven of calm punctuated with vibrant details, where soothing pastels and clever layouts come together seamlessly. The living room serves as a delightful introduction, its crisp white backdrop softened by gentle hues of blue and pink, while cheerful yellow accents add a lively touch. The result is a space that feels airy and intimate, perfect for both relaxation and gathering. Located in Kanjurmarg, Mumbai, this compact home redefines urban living with its creative approach to design.",
        images: [blissCover, bliss1, bliss2, bliss3],
    },
    {
        header: "VATSALYA",
        folder: "Vatsalya",
        paragraph: "Rooted in tradition yet effortlessly modern, Vatsalya is a finely crafted 3BHK residence in Borivali that exemplifies a thoughtful balance between Indian heritage and contemporary design. This home is a study in warmth, functionality, and aesthetic refinement. Deep-toned wooden laminates establish a cohesive visual language, while intricate artisanal details and space-maximizing solutions lend a distinct character to the interiors. Every element, from handcrafted motifs to smartly integrated furniture, is meticulously curated to enhance both form and function.",
        images: [vatsalyaCover, vatsalya1, vatsalya2, vatsalya3],
    },
    {
        header: "SAANJ",
        folder: "Saanj",
        paragraph: "Nestled in the vibrant lanes of Bandra, Mumbai, Saanj is a 2BHK renovation project that redefines urban elegance with a quiet nod to Indian sensibilities. This home embraces a restrained white palette, natural materials, and soft textures to create an atmosphere that is equal parts chic and comforting. Every element — from the carefully layered finishes to the thoughtful choice of materials — reflects a design sensibility rooted in understated luxury.",
        images: [saanjCover, saanj1, saanj2, saanj3],
    },
    {
        header: "ANGAN",
        folder: "Aangan",
        paragraph: "Step into this chic 2BHK home where Japandi calm meets playful chic modernity. Drenched in a palette of pastel blue pink, mellow yellow, beige and greens, the space feels like a breath of fresh air. The open-plan living room embraces light with a mustard curved sofa, cane chair and sleek TV unit, while a hidden study inside a wooden-cane cabinet adds functional charm. A kitchen wall was broken to make way for a cozy breakfast counter with high chairs, blending flow and functionality. The master bedroom bursts with youthful flair—checkered wallpaper on the ceiling, scalloped mirrors, a striped yellow headboard, and denim-toned wardrobe—all grounded by wooden flooring and plants. The parents' room balances maturity with patterned soft furnishings. Throughout the home, limewash-textured walls create a “Chic-andi”* vibe—a coined blend of chic and Japandi, wrapped in boho soul. It’s a space that feels serene, spirited, and unapologetically fresh.",
        images: [anganCover, angan1, angan2, angan3],
    },
    {
        header: "AC STUDIO",
        folder: "AC office",
        paragraph: "Tucked behind a bold black entrance door, this newly designed studio of Alchemy Collective, an interior design and architecture firm is a spatial embodiment of the studio’s core philosophy — fun, quirky, chic, and deeply rooted in material exploration. Designed and executed by the founders themselves, this workspace isn’t just an office — it’s a material lab, a visual identity, and a daily source of inspiration for the creative team.",
        images: [acStudioCover, acStudio1, acStudio2, acStudio3],
    },
    {
        header: "PALMIRA",
        folder: "Palmira",
        paragraph: "This recently completed 2BHK home channels an effortlessly chic and tropical vibe, making it a tranquil escape nestled in the heart of the city. Designed to feel open, sun-drenched, and full of life, the interiors embrace natural light and a palette that feels balmy and breezy all year round.",
        images: [palmiraCover, palmira1, palmira2, palmira3],
    },
    {
        header: "NEELAYA",
        folder: "Neelaya",
        paragraph: "This home reinterprets the principles of Indian design through a minimal contemporary lens. Designed for a young family, this 2BHK Mumbai home embraces the warmth of dark wood as its central narrative, effortlessly blending traditional materiality with a calming, modern sensibility.",
        images: [neelayaCover, neelaya1, neelaya2, neelaya3],
    },
    {
        header: "CASSARA",
        folder: "Cassara",
        paragraph: "Nestled in the heart of Kandivali West, this newly completed 3BHK home is a thoughtful blend of eclectic charm and bohemian serenity. Designed to be a calm, welcoming space that balances functionality with style, the interiors embrace a white-dominant palette layered with textures, prints, and vibrant pops of color—creating a home that feels both lived-in and curated.",
        images: [cassaraCover, cassara1, cassara2, cassara3],
    },
    {
        header: "AMARA",
        folder: "Amara",
        paragraph: "A serene sanctuary in the heart of Mumbai, this 4BHK home unfolds like a quiet exhale from the city’s constant motion. Designed with a language of calm minimalism and crafted detail, the space embraces neutral hues, warm wood accents, and a timeless sense of balance. This home celebrates restraint, texture, and soul — proof that calm need not be plain, and simplicity, when done with intention, can be its own form of luxury.",
        images: [amaraCover, amara1, amara2, amara3],
    },
    {
        header: "AURELIA",
        folder: "Aurelia",
        paragraph: "Imagine waking in a chic bohemian embrace, where soft pastels and bold pops awaken your senses daily. Nostalgic swings whisper childhood joys, natural light dances through connected spaces, and earthy textures cradle every moment. Here, modernism meets free-spirited whimsy—family bonds deepen, creativity flows, and life unfolds in harmonious, soul-nourishing serenity.",
        images: [aureliaCover, aurelia1, aurelia2, aurelia3],
    },
    {
        header: "REVERIE",
        folder: "Reverie",
        paragraph: "True to its name, Reverie is a home designed as a gentle escape from the mundane—a space that invites you to pause, breathe, and daydream. Washed in soft, natural light and adorned with a palette of soothing neutrals, this home feels less like a structure and more like a feeling. Every corner is thoughtfully curated to evoke a sense of calm, with tactile textures and organic forms creating a seamless flow between spaces. It is a sanctuary where time seems to slow down, offering a perfect backdrop for life’s quietest, most beautiful moments.",
        images: [reverieCover, reverie1, reverie2, reverie3],
    },
];

export default projectsData;
